import React from 'react'

import getApiListReport from '../api/listReports'
import deleteApiListReport from '../api/deleteReport'
import publishReport from '../api/publishReport'
import duplicateReports from '../api/duplicateReport'

import ReportList from '../Form/components/ReportList/reportList'

export default function Home(): JSX.Element {
    return (
        <div>
            <ReportList
                getReports={getApiListReport}
                deleteReports={deleteApiListReport}
                publishReports={publishReport}
                duplicateReports={duplicateReports}
            />
        </div>
    )
}
